var _ellipse, _ellipse2, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.09241,
    cy: 5.52291,
    rx: 4.59241,
    ry: 4.52291,
    stroke: "black",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.9069,
    cy: 5.52291,
    rx: 4.59241,
    ry: 4.52291,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.5625C9.375 8.5625 17.0748 17.4337 30.3182 17.4337C43.5617 17.4337 51.2614 8.5625 51.2614 8.5625",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36816 15.6284C3.36816 15.0761 3.81588 14.6284 4.36816 14.6284H7.91199C8.46428 14.6284 8.91199 15.0761 8.91199 15.6284V41.9293H3.36816V15.6284Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1377 15.6284C52.1377 15.0761 52.5854 14.6284 53.1377 14.6284H56.6815C57.2338 14.6284 57.6815 15.0761 57.6815 15.6284V41.9293H52.1377V15.6284Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.3145,
    y: 41.9292,
    width: 9.18508,
    height: 5.00415,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.54883,
    y: 41.9292,
    width: 9.18508,
    height: 5.00415,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12402 9.64014V14.8824",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9092 9.64014V14.8824",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7461 29.1903C22.776 29.0819 22.8746 29.0068 22.9871 29.0068H37.8825C37.9941 29.0068 38.0921 29.0807 38.1228 29.188L43.4932 47.931C43.539 48.0907 43.4191 48.2499 43.2529 48.2499H17.8153C17.6501 48.2499 17.5303 48.0926 17.5743 47.9334L22.7461 29.1903Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/managerIcon.2ea5e5fe129d2b7a025ff1f79eca384c.svg";
export { ForwardRef as ReactComponent };